// Algunos lectores de codigo de barras, segun como tengan configurado su layout de
// teclado, escriben apostrofe (') en vez de guion (-) para el mismo caracter leido
// del codigo (es un problema de configuracion del lector, no del codigo de barras en
// si, que siempre codifica el codigo real con guiones). Normalizamos sacando esos
// separadores antes de comparar, para que el escaneo encuentre el producto sin
// importar cual de los dos caracteres haya tipeado el lector.
export function normalizarCodigo(codigo: string | null | undefined): string {
  return (codigo || '').trim().toUpperCase().replace(/['-]/g, '');
}
